import * as React from "react";
const SvgAhrefs = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 67.8 82.6",
  width: "1em",
  height: "1em",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F80",
  d: "M7.1 17.9h40.8v11.5l-15.3 1.2C7.8 32.3 0 38.9 0 57.3V61c0 13.5 9.4 21.6 23.9 21.6 11.5 0 18-2.7 26.1-11h1.3v8.8h16.3V0H7.1zm40.8 38.7C42.8 61.7 35.3 65 29 65c-6.7 0-9.6-2.5-9.4-8.1.2-7.8 3-9.6 16-10.8L47.9 45z"
}));
export default SvgAhrefs;
//# sourceMappingURL=Ahrefs.js.map